import { DateRangeValue, INFINITY } from '@redngapps/shared/date/types';
import { SoftwareProducer } from '@redngapps/shared/types';

export const softwareProducerEmails = {
  emailSupport: 'support@redmedical.de',
  emailInfo: 'info@redmedical.de',
  emailPrivacyOfficer: 'b.sandrock@alarmstufe-red.de',
};

export const softwareProducer: SoftwareProducer = {
  name: 'RED Medical Systems GmbH',
  street: 'Lutzstrasse 2',
  zipCode: '80687',
  city: 'München',
  phone: '089/997 43 72 50',
  fax: '089/997 43 72 50',
  email: softwareProducerEmails.emailSupport,
};

export const software = 'RED Medical';

/**
 * Always remember to adjust the validTo date,
 * because we never know for sure the validity end date.
 * Therefore we set the validTo date to 'infinity'.
 */
export const kbvPruefnummern: DateRangeValue[] = [
  {
    validFrom: '2018-12-01',
    validTo: '2021-12-31',
    value: 'Y/1/1812/37/626',
  },
  {
    validFrom: '2022-01-01',
    validTo: '2022-06-30',
    value: 'Y/1/2201/06/626',
  },
  {
    validFrom: '2022-07-01',
    validTo: '2025-06-30',
    value: 'Y/1/2207/36/626',
  },
  {
    validFrom: '2025-07-01',
    validTo: INFINITY,
    value: 'Y/1/2507/36/626',
  },
];

/**
 * This number must be send with each eAu outside of the Referenzumgebung (RU).
 */
export const kbvPruefnummernEau: DateRangeValue[] = [
  {
    validFrom: '2023-07-01',
    validTo: '2024-07-31',
    value: 'Y/80/2108/36/626',
  },
  {
    validFrom: '2024-08-01',
    validTo: '2026-07-31',
    value: 'Y/80/2408/24/626',
  },
  {
    validFrom: '2026-08-01',
    validTo: INFINITY,
    value: 'Y/80/2608/35/626',
  },
];
